import { jsx as _jsx } from "react/jsx-runtime";
import { Card, Tooltip } from 'antd';
import { useEffect, useState } from 'react';
import UIText from './uiText';
import UIValidation from './uiValidation';
import UIValue from './uiValue';
const { Meta } = Card;
function UIImageButtonComponent(props) {
    const [selected, setSelected] = useState(props.selected);
    useEffect(() => {
        setSelected(props.selected);
    }, [props.selected]);
    const onClick = () => {
        if (props.onClick) {
            props.onClick();
        }
    };
    const style = {
        width: 300,
        marginTop: '20px',
        marginBottom: '20px',
        borderRadius: '8px',
    };
    if (selected) {
        Object.assign(style, {
            border: '2px solid #ff5c35',
        });
    }
    else {
        Object.assign(style, {
            border: '2px solid #808080',
        });
    }
    // Some trickery because flexbox doesn't support ellipses truncation
    const truncatedSubtitle = props.subtitle.length > 100 ? props.subtitle.slice(0, 100).trim() + '...' : props.subtitle;
    return (_jsx(Card, { style: style, cover: _jsx("img", { alt: "example", src: props.image }), onClick: onClick, hoverable: true, children: _jsx(Meta, { title: props.title, description: _jsx(Tooltip, { title: props.subtitle, children: _jsx("div", { style: {
                        display: 'flex',
                        flexDirection: 'column',
                        flexWrap: 'nowrap',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        height: '4.5em',
                        lineHeight: '1.5em',
                        maxHeight: '4.5em',
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        cursor: 'pointer',
                    }, children: truncatedSubtitle }) }) }) }));
}
export default class UIImageButton extends UIValue {
    title;
    subtitle;
    image;
    text;
    onClick;
    borderColor;
    constructor(s) {
        super(s);
        this.title = this.getProperty('title');
        this.subtitle = this.getProperty('subtitle', '');
        this.image = this.getProperty('image');
        this.value = false;
        if ('text' in s) {
            this.text = new UIText(s);
        }
        this.borderColor = '#d9d9d9';
        this.onClick = () => { };
    }
    getComponent() {
        const text = this.text !== undefined ? this.text.getComponent() : null;
        const props = {
            title: this.title,
            subtitle: this.subtitle,
            image: this.image,
            borderColor: this.borderColor,
            text: text,
            selected: this.value,
            onClick: this.onClick,
        };
        return (_jsx(UIValidation, { error: this.error, children: _jsx(UIImageButtonComponent, { ...props }) }));
    }
}
//# sourceMappingURL=uiImageButton.js.map